import { AfterViewInit, Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { ClientSignatureType, OrderClientRelation } from '../../../../core';
import { OrderClient } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-operate-form-sign',
    templateUrl: './operate-form-sign.component.html',
    styleUrls: ['./operate-form-sign.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OperateFormSignComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public ClientSignatureType: typeof ClientSignatureType = ClientSignatureType;
    public OrderClientRelation: typeof OrderClientRelation = OrderClientRelation;

    @Input()
    signedBy: 'all' | 'one' = 'one';

    @Input()
    allowDigital = true;

    @Input()
    allowHandwritten = true;

    @Input()
    participants: OrderClient[] = [];

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    get isSigned(): boolean {
        if (this.signedBy === 'one') {
            return this.participants.some((participant) => !!participant.signatureType);
        }

        return !this.participants.some((participant) => !participant.signatureType);
    }

    onParticipantSign(participant: OrderClient, signatureType: ClientSignatureType) {
        if (this.signedBy === 'one') {
            this.participants.map((it) => {
                it.signatureType = undefined;
            });
        }

        participant.signatureType = signatureType;
    }
}
